import AppHome from "@/views/AppHome.vue";

export default [
  {
    path: "/home",
    name: "AppInicio",
    component: AppHome,
  },
];
